import React from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export default function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      {icon && (
        <div
          className="w-14 h-14 rounded-full flex items-center justify-center mb-5"
          style={{ background: 'rgba(76,201,255,0.08)', border: '1px solid rgba(76,201,255,0.15)' }}
        >
          {icon}
        </div>
      )}
      <h3 className="font-display font-semibold text-[18px] mb-2" style={{ color: '#F2F4FF' }}>
        {title}
      </h3>
      {description && (
        <p className="text-[14px] leading-relaxed max-w-sm" style={{ color: '#A7A3C4' }}>
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
